<template>
  <div class="dialog-cancel-complete">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <span class="title">
          {{ $t('transactions.dialog.cancel_complete.title') }}
        </span>
      </div>
      <div class="main">
        <div class="group-label">
          <label class="label">{{ $t('transactions.id') }}: p{{ transaction.id }}</label><br>
          <label class="label">
            {{ transaction.shop.name }} ({{ $dayjs(transaction.transaction_datetime).format('YY/MM/DD  HH:mm') }})
          </label>
        </div>
        <span class="content">
          <span class="notice">{{ $t('transactions.dialog.cancel_complete.notice') }}</span><br>
          <span class="detail">
            {{ getUser() }}さん <span class="plus">+{{ transaction.point_formated }}{{ $t('kokoron') }} </span>｜
            {{ getStaff() }}さん <span class="minus">-{{ transaction.point_formated }}{{ $t('kokoron') }}</span>
          </span>
        </span>
      </div>
      <div class="footer">
        <el-button @click="handleBackList" class="btn btn-back">{{ $t('transactions.btn_label.back') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      openNotiCancelComplete: { type: Boolean, required: true, default: false },
      transaction: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
    },
    emits: ['isClosePopupNoti'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        isClose: false,
        loading: false
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupNoti');
      },

      handleBackList() {
        window.location.href = this.urls.index;
      },

      getStaff() {
        if (this.transaction.staff) {
          return (this.transaction.staff.first_name ? this.transaction.staff.first_name : '')
          + (this.transaction.staff.last_name ? this.transaction.staff.last_name : '')
            + ' (' + this.transaction.staff.nickname + ')';
        }
        return '';
      },

      getUser() {
        if (this.transaction.user) {
          return (this.transaction.user.first_name ? this.transaction.user.first_name : '')
          + (this.transaction.user.last_name ? this.transaction.user.last_name : '')
            + ' (' + this.transaction.user.nickname + ')';
        }
        return '';
      },
    },

    created() {
      this.dialog = this.openNotiCancelComplete;
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-cancel-complete {
    text-align: center;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      text-align: center;
      font-weight: 700;
    }
    .main {
      letter-spacing: 0.75px;
      color: #000000;
      text-align: center;
      font: normal normal normal 14px/35px Kozuka Gothic Pr6N;
      letter-spacing: 1.4px;
      .label {
        font: normal normal normal 14px/35px Kozuka Gothic Pr6N;
        letter-spacing: 1.4px;
        color: #000000;
      }
      .content {
        font-weight: bold;
        .detail {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .group-label {
        padding: 20px 0;
      }
      .notice {
        font: normal normal normal 13px/35px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
      }
      .plus {
        color: #468349;
      }
      .minus {
        color: #AC3B29;
      }
      .detail {
        font: normal normal normal 14px/35px Kozuka Gothic Pr6N;
        letter-spacing: 1.6px;
        color: #000000;
      }
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 200px;
        height: 50px;
        border-radius: 25px !important;
      }
      .btn-edit {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
      }
    }
  }
</style>
